/**
 * Created by JAVIER on 10/29/2019.
 */

import React from 'react';
import { Modal, Carousel, Tooltip, Icon } from 'antd';

import './modalCarousel.css'
import BigPhoto from "./BigPhoto";


class ModalCarousel extends React.Component{

    constructor(props){
        super(props);
        console.log ("calling constructors:", props);
        this.bigPhotos = [];
    }

    rotate = async () => {
        this.currentSlide =  this.currentSlide || this.props.initialSlide;
        const bigPhoto = this.bigPhotos[this.currentSlide];
        const rotation = await bigPhoto.rotate();
        this.props.smallPhotos[bigPhoto.props.file._id].setRotation(rotation);
    }

    reset = async () => {
        this.currentSlide =  this.currentSlide || this.props.initialSlide;
        const bigPhoto = this.bigPhotos[this.currentSlide];
        const rotation = await bigPhoto.reset();
        this.props.smallPhotos[bigPhoto.props.file._id].setRotation(rotation);
    }

    renderPhotos = (photos)=>{

        if ( this.props.shared === true ) {
            let list = photos.map((p, idx) => {
                if ( p.displayInSharedLink === "true" ) {
                    return (
                        <BigPhoto file={p} key={idx} ref={ (e) => {
                            this.bigPhotos[idx] = e;
                        }} shared={this.props.shared} token={this.props.token}/>
                    )
                }
            });
            return list;
        }
        else {
            let list = photos.map((p, idx) => {
                return (
                    <BigPhoto file={p} key={idx} ref={ (e) => {
                        this.bigPhotos[idx] = e;
                    }} shared={this.props.shared} token={this.props.token}/>
                )
            });
            return list;
        }
    }

    render(){
        console.log("render carousel...");
        this.currentSlide = null;
        return (
            <Modal
                id="photos"
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                footer={null}
                centered
                width={930}
                bodyStyle={{
                    background: 'linear-gradient(to left, black, 10%, gray, 90%, black)'
                }}
            >
                <div >
                   {/* { this.props.shared !== true &&
                        <Tooltip placement="top" title={'rotate'}>
                            <Icon
                                type="redo"
                                onClick={this.rotate}
                                style={{
                                    fontSize: '18px',
                                    color: "gray",
                                    cursor: "pointer",
                                    marginRight: "10px"
                                }}
                            />
                        </Tooltip>
                    }
                    { this.props.shared !== true &&
                        <Tooltip placement="top" title={'reset'}>
                            <Icon
                                type="pic-center"
                                onClick={this.reset}
                                style={{
                                    fontSize: '18px',
                                    color: "gray",
                                    cursor: "pointer"
                                }}
                            />
                        </Tooltip>
                    }*/}

                </div>

                <div style={{margin: '15px'}}>
                    <Carousel afterChange={(e) => {
                        this.currentSlide = e;
                    }}
                              dots={false}
                              arrows={true}
                              infinite={false}
                              initialSlide={this.props.initialSlide}
                              key={new Date().getMilliseconds()} >
                        {
                            this.renderPhotos(this.props.photos)
                        }
                    </Carousel>
                </div>
            </Modal>
        )
    }
}

export default ModalCarousel;